import { render, staticRenderFns } from "./TCFDTable.vue?vue&type=template&id=42fa74fe"
import script from "./TCFDTable.vue?vue&type=script&lang=js"
export * from "./TCFDTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports